import { installRuntimeErrorMonitor } from '@/lib/runtime-error-monitor';

// Keep the early hook small. Load auth/store/diagnostic dependencies only when
// there is an error, then use the same API → Sentry path as React boundaries.
installRuntimeErrorMonitor(window, async (error, source) => {
  const { reportClientError } = await import('@/lib/client-errors');
  await reportClientError({ error, extra: { source } });
});
